const translations = {
    resources: {
        invoices: {
            name: 'Facture |||| Factures',
            fields: {
                invoice_type: 'Type de facture',
                invoiced_at: 'Facturé le',
                due_date: 'Date d\'échéance',
                total_taxed: 'Total taxé',
                total_untaxed: 'Total non taxé',
                start_date: 'Date de début',
                end_date: 'Date de fin',
                status: 'Statut',
                number: 'Numéro',
                billing_company_id: 'Société de facturation',
                customer_id: 'Client'
            }
        },
        leaves: {
            name: 'Congé |||| Congés',
            fields: {
                start_date: 'Date de début',
                end_date: 'Date de fin',
                duration: 'Durée',
                status: 'Statut',
                comments: 'Commentaires',
                user_id: 'Utilisateur',
                half_day: 'Demi-jour'
            }
        },
        customers: {
            name: 'Client |||| Clients',
            fields: {
                name: 'Nom',
                short_name: 'Nom court'
            }
        },
        projects: {
            name: 'Projet |||| Projets',
            fields: {
                name: 'Nom',
                status: 'Statut',
                color: 'Couleur',
                customer_id: 'Client',
                start_date: 'Date de début',
                end_date: 'Date de fin',
                category: 'Catégorie',
                updated_at: 'Mis à jour le'
            }
        },
        time_entries: {
            name: 'Timesheet |||| Timesheet',
            fields: {
                hours: 'Heures',
                invoiced: 'Facturé',
                project_id: 'Projet',
                created_at: 'Créé le',
                default_date: 'Date par défaut'
            }
        },
        time_entry_types: {
            name: 'Type timesheet |||| Types timesheet',
            fields: {
                name: 'Nom'
            }
        },
        weeklies: {
            fields: {
                workload: 'Charge de travail',
                occupancy_rate: 'Taux d\'occupation',
                priorities: 'Priorités',
                tasks: 'Tâches',
                created_at: 'Créé le'
            }
        },
        suggestions: {
            fields: {
                title: 'Titre',
                category: 'Catégorie',
                status: 'Statut',
                created_at: 'Créé le'
            }
        },
        articles: {
            fields: {
                title: 'Titre',
                category: 'Catégorie',
                published: 'Publié',
                published_at: 'Publié le',
                content: 'Contenu',
                author: 'Auteur'
            }
        },
        news: {
            fields: {
                title: 'Titre',
                category: 'Catégorie',
                published: 'Publié',
                published_at: 'Publié le',
                content: 'Contenu',
                author: 'Auteur'
            }
        },
        users: {
            name: 'Utilisateur |||| Utilisateurs',
            fields: {
                active: 'Actif',
                email: 'E-mail',
                firstname: 'Prénom',
                lastname: 'Nom',
                password: 'Mot de passe',
                trigram: 'Trigramme',
                color: 'Couleur',
                status: 'Statut'
            }
        },
        account: {
            fields: {
                firstname: 'Prénom',
                lastname: 'Nom',
                password: 'Mot de passe'
            }
        },
        companies: {
            name: 'Société de facturation |||| Sociétés de facturation',
            fields: {
                name: 'Nom',
                country: 'Pays',
                street: 'Rue',
                zipcode: 'Code postal',
                city: 'Ville',
                vat_number: 'Numéro TVA',
                bank_name: 'Nom banque',
                bank_bic: 'BIC banque',
                bank_iban: 'IBAN banque',
                website: 'Site web',
                phone: 'Téléphone',
                updated_at: 'Mis à jour le'
            }
        },
        costs: {
            name: 'Coût |||| Coûts',
            fields: {
                name: 'Nom',
                vendor: 'Fournisseur',
                amount: 'Montant',
                frequency: 'Fréquence',
                start_date: 'Date de début',
                end_date: 'Date de fin',
                category: 'Catégorie',
                amount_min: 'Montant min',
                amount_max: 'Montant max',
                is_variable: 'Est variable'
            }
        },
        budgets: {
            fields: {
                customer_id: 'Client',
                project_id: 'Projet',
                budget_type: 'Type de budget',
                hours_included: 'Heures incluses',
                amount: 'Montant',
                start_date: 'Date de début',
                end_date: 'Date de fin',
                is_active: 'Est actif'
            }
        }
    },
    'User': 'Utilisateur',
    'Name': 'Nom',
    'Number of days': 'Nombre de jours',
    'Search': 'Recherche',
    'Account': 'Compte',
    'Account updated': 'Compte mis à jour',
    'Leave validation': 'Validation du congé',
    'Other leaves at the same period': 'Autres congés à la même période',
    'Pending': 'En attente',
    'Accepted': 'Accepté',
    'Refused': 'Refusé',
    'Leave': 'Congé',
    'Recup': 'Récup',
    'Sick leave': 'Congé maladie',
    'Unpaid leave': 'Congé sans solde',
    'Other': 'Autre',
    'Useful links': 'Liens utiles',
    'Leaves': 'Congés',
    'Must be from the same month': 'Doit être du même mois',
    'Pending leaves': 'Congés en attente',
    'Current month': 'Mois courant',
    'This month': 'Ce mois-ci',
    'Next month': 'Mois prochain',
    'Last month': 'Mois précédent',
    'This year': 'Cette année',
    'Last year': 'L\'année dernière',
    'Reset': 'Réinitialiser',
    'Leave taken': 'Congés pris',
    'Remaining leave': 'Congés restants',
    'Recuperation days': 'Jours de récupération',
    'Other leave days': 'Autres jours de congés',
    'leaves.unpaid': 'Sans solde',
    'leaves.sick': 'Maladie',
    'Unpaid leave days': 'Congés sans solde',
    'Customer': 'Client',
    'Users': 'Utilisateurs',
    'Active': 'Actif',
    'Maintenance': 'Maintenance',
    'Paused': 'En pause',
    'Done': 'Fini',
    'Late': 'En retard',
    'Cancelled': 'Annulé',
    'Summary': 'Résumé',
    'Projects': 'Projets',
    'Project': 'Projet',
    'My projects only': 'Mes projets uniquement',
    'Hours': 'Heures',
    'Help': 'Aide',
    'Minimum duration of 0.25h': 'Durée minimum de 0,25h',
    '0.25h = 15 minutes': '0,25h = 15 minutes',
    'Set invoiced': 'Facturé(s)',
    'Last time entry': 'Dernière entrée timesheet',
    'Capacity': 'Capacité',
    'Last 7 days timesheet': 'Timesheet des 7 derniers jours',
    'Next leaves': 'Prochains congés',
    'My projects': 'Mes projets',
    'Links': 'Liens',
    'Last time entries': 'Dernières entrées timesheet',
    'Available': 'Disponible',
    'Low': 'Bas',
    'Normal': 'Normal',
    'High': 'Haut',
    'Overloaded': 'Surchargé',
    'Blocked': 'Bloqué',
    'My documents': 'Mes documents',
    'Priorities': 'Priorités',
    'Tasks': 'Tâches',
    'Last weekly': 'Dernier weekly',
    'Last monthly': 'Dernier monthly',
    'Never': 'Jamais',
    'See more': 'Voir plus',
    'Last Redmine tickets': 'Derniers tickets Redmine',
    'Accept': 'Accepter',
    'Refuse': 'Refuser',
    'Achievements': 'Succès',
    'Disciple of Nurgle': 'Disciple de Nurgle',
    'Took one day\'s sick leave': 'A pris un jour de congé maladie',
    'Took part in many meetings': 'A participé à beaucoup de réunions',
    'Took part in many calls and discussions': 'A participé à beaucoup d\'appels et de discussions',
    'Involved in many projects': 'Impliqué dans de nombreux projets',
    'Has filled his timesheet many times': 'A rempli sa timesheet de nombreuses fois',
    'Has filled his timesheet many times with more than 8 hours a day': 'A rempli sa timesheet de nombreuses fois avec plus de 8h par jour',
    'More work?': 'Encore du travail?',
    'Pain reinforces devotion': 'La douleur renforce la dévotion',
    'Time is an illusion. Lunchtime doubly so.': 'Le temps est une illusion. En particulier l\'heure du déjeuner.',
    'Marathoner': 'Marathonien',
    'Underwent very long meetings': 'A subi de très longues réunions',
    'Hang by a thread': 'Ne tenir qu\'à un fil',
    'The nugget': 'La pépite',
    'Has done a lot of prospecting': 'A fait beaucoup de prospection',
    'For those who come after': 'Pour ceux qui viendront après',
    'Has done a lot of testing': 'A effectué de nombreux tests',
    'The scholar': 'L\'érudit',
    'Has done a lot of documentation': 'A fait beaucoup de documentation',
    'The Pretender': 'Le Caméléon',
    'Has filled his timesheet many times in many types of activity': 'A rempli sa timesheet de nombreuses fois avec des activités variées',
    'There are Pretenders among us. Geniuses with the ability to become anyone they want to be.': 'Il existe des êtres doués d\'une intelligence supra normale, des génies qui possèdent entre autres la faculté d\'assumer n\'importe quelle identité.',
    'Did you tried turning it off and on again?': 'Avez-vous essayé de l\'éteindre et de le rallumer?',
    'Has done a lot of support': 'A fait beaucoup de support',
    'It is by doing whatever that we become whoever': 'C\'est en faisant n\'importe quoi qu\'on devient n\'importe qui',
    'Has done a lot of indescribable things': 'A fait beaucoup de choses indescriptibles',
    'Stack Overflow thief': 'Pillard de Stack Overflow',
    'Has done a lot of development': 'A fait beaucoup de développement',
    '2px to the right': '2px à droite',
    'Has done a lot of design': 'A fait beaucoup de design',
    'Month': 'Mois',
    'January': 'Janvier',
    'February': 'Février',
    'March': 'Mars',
    'April': 'Avril',
    'May': 'Mai',
    'June': 'Juin',
    'July': 'Juillet',
    'August': 'Août',
    'September': 'Septembre',
    'October': 'Octobre',
    'November': 'Novembre',
    'December': 'Décembre',
    'Ideas box': 'Boîte à idées',
    'Comments': 'Commentaires',
    'Comment': 'Commentaire',
    'Comment added': 'Commentaire ajouté',
    'Comment could not be added': 'Le commentaire n\'a pas pu être ajouté',
    'Add': 'Ajouter',
    'Today': 'Aujourd\'hui',
    'For me': 'Pour moi',
    'Refuse the suggestion?': 'Refuser la suggestion?',
    'Accept the suggestion?': 'Accepter la suggestion?',
    'Occupancy rate': 'Taux d\'occupation',
    'Workload': 'Charge de travail',
    'Active projects': 'Projets actifs',
    'Team status': 'Statut de l\'équipe',
    'Estimate the number of days you are busy during the week': 'Estimation du nombre de jours où tu es occupé sur la semaine',
    'updated': 'mis à jour',
    'by': 'par',
    'New suggestions': 'Nouvelles suggestions',
    'Status': 'Statut',
    'Calendar': 'Calendrier',
    'List': 'Liste',
    'This field can be edited. Don\'t forget to deduct half days.': 'Ce champ est éditable. N\'oubliez pas de déduire les demi-jours.',
    'Timesheet not up to date': 'Timesheet pas à jour',
    'Weekly to create': 'Weekly à créer',
    'Total hours': 'Total heures',
    'items': 'éléments',
    'My weeklies only': 'Mes weeklies uniquement',
    'Quests': 'Quêtes',
    'Fill in my timesheet': 'Remplir ma timesheet',
    'Create my weekly': 'Créer mon weekly',
    'Check that my leaves have been filled correctly': 'Vérifier si mes congés ont été remplis correctement',
    'Unvoted': 'Non voté',
    'Vote for %{count} suggestions': 'Voter pour %{count} suggestions',
    'Rules': 'Règlement',
    'Privacy': 'Confidentialité',
    'Leaderboard': 'Classement',
    'My impact': 'Mon impact',
    'Personal': 'Personnel',
    'total hours/max capacity': 'heures totales/capacité max',
    'hours worked/total hours': 'heures prestées/heures totales',
    'Most commonly used types': 'Types les plus utilisés',
    'Most commonly used types in timesheet': 'Types les plus utilisés dans la timesheet',
    'Project count': 'Nombre de projets',
    'Days filled in timesheet': 'Jours remplis dans la timesheet',
    'Only leaves with type "leave" are counted.': 'Seuls les congés de type "congé" sont comptabilisés.',
    'Make two different requests if your leaves overlap two months (this will make the automatic calculations easier).': 'Il faut faire deux demandes distinctes si les congés chevauchent deux mois (afin de faciliter le calcul automatique).',
    'The field "number of days" can be edited. Don\'t forget to deduct half days.': 'Le champ "nombre de jours" est éditable. N\'oubliez pas de déduire les demi-jours',
    'Settings': 'Paramètres',
    'Web process': 'Process web',
    'Project follow-up': 'Suivi de projet',
    'Quick actions': 'Actions rapides',
    'Visible on': 'Visible sur',
    'On all pages': 'Sur toutes les pages',
    'Disabled': 'Désactivé',
    'Figma process': 'Process Figma',
    'No data for this month': 'Pas de données pour ce mois',
    'Days': 'Jours',
    'Settings updated': 'Paramètres mis à jour',
    'More information here': 'Plus d\'informations ici',
    'Billing companies': 'Sociétés de facturation',
    'Billing addresses': 'Adresses de facturation',
    'Archived': 'Archivé',
    'Timesheet calendar': 'Calendrier timesheet',
    'Addresses': 'Adresses',
    'Utilization %': 'Utilisation %',
    'Copy last weekly': 'Copier dernier weekly'
};

export default translations;
